import { OrgStructurePage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 仓库与科室（运营端本租户，门禁 sys:org:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端关闭租户维度。
 */
export default function OrgStructure() {
  return <OrgStructurePage hq={hq} />;
}
